import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";

import classNames from "classnames";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

//import action
import { getChartsData as onGetChartsData } from "../../store/actions";

// Dashboard Count API
import { DashboardCountApi } from "apis/DashboardCountApi";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import LatestTranaction from "./LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//locale aware counts
import { formatCount } from "../../helpers/language_helper";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";

const Dashboard = props => {
  const [modal, setmodal] = useState(false);
  const [subscribemodal, setSubscribemodal] = useState(false);
  const [dashboardCount, setDashboardCount] = useState([]);
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    getDashboardCount();
  }, []);

  // Dashboard Count Function
  const getDashboardCount = () => {
    DashboardCountApi.getAllDashboardCount()
      .then((res) => {
        setDashboardCount(res.data.data);
      }).catch((err) => {
        console.log(err);
      });
  };

  const { chartsData } = useSelector(state => ({
    chartsData: state.Dashboard.chartsData
  }));

  // counts come from the API as plain numbers; render them with the digits of
  // the selected language (Arabic-Indic for arab, Western for eng)
  const showCount = (value) =>
    value === undefined || value === null
      ? props.t("Loading...")
      : formatCount(value);

  // ----------------- Reports List -----------------
  // `link` is a stable, untranslated key - navigation must not depend on the
  // displayed title, which changes with the selected language
  const reports = [
    {
      title: props.t('USERS'),
      link: "/all-users",
      iconClass: "bx-copy-alt",
      description: showCount(dashboardCount[1]?.totalcount)
    },
    {
      title: props.t('BOOKINGS'),
      link: "/bookings",
      iconClass: "bx-archive-in",
      description: showCount(dashboardCount[3]?.totalcount)
    },

    // ✅ New Card Added for Admin Users
    {
      title: props.t('ADMIN USERS'),
      link: "/admin-users",
      iconClass: "bx-user-check",
      description: showCount(dashboardCount[0]?.totalcount)
    },

    {
      title: props.t('APPROVED SALONS'),
      link: "/salons?status=Approved",
      iconClass: "bx-purchase-tag-alt",
      description: showCount(dashboardCount[7]?.totalcount)
    },
    {
      title: props.t('PENDING SALONS'),
      link: "/salons?status=Pending",
      iconClass: "bx-purchase-tag-alt",
      description: showCount(dashboardCount[6]?.totalcount)
    },
    {
      title: props.t('REJECTED SALONS'),
      link: "/salons?status=Rejected",
      iconClass: "bx-purchase-tag-alt",
      description: showCount(dashboardCount[8]?.totalcount)
    },

    // ❌ Old commented code for reference
    /*
    {
      title: props.t('HOME SERVICES'),
      iconClass: "bx-purchase-tag-alt",
      description: !dashboardCount ? "Loading..." : dashboardCount[4].totalcount,
    },
    {
      title: props.t('SALON SERVICES'),
      iconClass: "bx-purchase-tag-alt",
      description: !dashboardCount ? "Loading..." : dashboardCount[5].totalcount,
    },
    {
      title: props.t('REGISTERED SALONS'),
      iconClass: "bx-purchase-tag-alt",
      description: !dashboardCount ? "Loading..." : dashboardCount[2].totalcount,
    },
    {
      title: props.t('Amendment Required'),
      iconClass: "bx-purchase-tag-alt",
      description: !dashboardCount ? "Loading..." : dashboardCount[9]?.totalcount,
    }
    */
  ];
  // ----------------- End Reports -----------------

  useEffect(() => {
    setTimeout(() => {
      setSubscribemodal(true);
    }, 2000);
  }, []);

  const [periodData, setPeriodData] = useState([]);
  const [periodType, setPeriodType] = useState("yearly");

  useEffect(() => {
    setPeriodData(chartsData);
  }, [chartsData]);

  const onChangeChartPeriod = pType => {
    setPeriodType(pType);
    dispatch(onGetChartsData(pType));
  };

  useEffect(() => {
    dispatch(onGetChartsData("yearly"));
  }, [dispatch]);

  //meta title
  document.title = props.t("Dashboard") + " | " + props.t("Salon");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          <Row>
            <Col xl="12">
              <Row>
                {/* Reports Render */}
                {reports.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card
                      className="mini-stats-wid"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        // ✅ Navigation rules - keyed off report.link so the
                        // cards keep working in every language
                        if (report.link) {
                          history.push(report.link);
                        }
                      }}
                    >
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            <h4 className="mb-0">{report.description}</h4>
                          </div>
                          <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle" style={{ backgroundColor: "#8B61A1" }}>
                              <i
                                className={
                                  "bx " + report.iconClass + " font-size-24"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
